import React from 'react'
import Card from '../../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Formas de pagamento</h1>

				<h1 className="text-red-500 mb-4">Em construção...</h1>

				<p>Gerenciamento dos cartões de crédito cadastrados</p>
				<p>Cartões alternativos</p>
			</Card>
		</div>
	)
}
